<template>
    <!-- Era `CFooter`: la classe CoreUI 3 basta, il componente no. -->
    <footer class="c-footer">
        <div>&nbsp;</div>
        <div class="ml-auto">v{{ version }}</div>
    </footer>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'TheFooter',
    data() {
        return {
            version: this.$config.FRONTEND_VERSION,
        };
    },
});
</script>
